import type { ElementSchemaType, TestAnswerFeedbackSchemaType } from '@vedalib/editor/lib/brand'
import type { ElementValue } from '@vedalib/editor/lib/elements'
import { t } from 'i18next'
import React, { useMemo } from 'react'

import type { FCFormBrandType } from 'components/Editor/EditorElements/elements.types'
import { FormField } from 'components/formKit'
import { Typography } from 'components/uiKit/Typography'
import { FEEDBACK_SCHEMA_FIELDS } from 'services/Branding/fieldConfigs'
import { useUpdateSchema } from 'services/Branding/hooks'

const BrandFeedback: FCFormBrandType<
  ElementValue,
  ElementSchemaType,
  ElementSchemaType,
  TestAnswerFeedbackSchemaType
> = ({ device, subConfigs }) => {
  const stylePath = useMemo(() => ['feedback', device], [device])
  const schema = useUpdateSchema(stylePath, subConfigs, FEEDBACK_SCHEMA_FIELDS)

  return (
    <>
      <Typography weight='medium'>{t('elements.testAnswerFeedback.tags.correct')}</Typography>
      <FormField config={schema.correct.backgroundImage} />
      <FormField config={schema.correct.backgroundColor} />
      <FormField config={schema.correct.color} />
      <FormField config={schema.incorrect.backgroundImage} />
      <FormField config={schema.incorrect.backgroundColor} />
      <FormField config={schema.incorrect.color} />
      <FormField config={schema.common__var.width} />
      <FormField config={schema.common__var.height} />
      <FormField config={schema.common__var.marginRight} />

      <Typography weight='medium'>{t('elements.testAnswerFeedback.tags.common')}</Typography>
      <FormField config={schema.common.borderRadius} />
      <FormField config={schema.common.displayIcon} />

      <Typography weight='medium'>{t('elements.testFeedback.tags.infoPanel')}</Typography>
      <FormField config={schema.info.backgroundImage} />
      <FormField config={schema.info.backgroundColor} />
      <FormField config={schema.info.borderStyle} />
      <FormField config={schema.info.borderColor} />
      <FormField config={schema.info.borderWidth} />

      <Typography weight='medium'>{t('elements.testFeedback.tags.successPanel')}</Typography>
      <FormField config={schema.success.backgroundImage} />
      <FormField config={schema.success.backgroundColor} />
      <FormField config={schema.success.borderStyle} />
      <FormField config={schema.success.borderColor} />
      <FormField config={schema.success.borderWidth} />

      <Typography weight='medium'>{t('elements.testFeedback.tags.failPanel')}</Typography>
      <FormField config={schema.fail.backgroundImage} />
      <FormField config={schema.fail.backgroundColor} />
      <FormField config={schema.fail.borderStyle} />
      <FormField config={schema.fail.borderColor} />
      <FormField config={schema.fail.borderWidth} />

      <Typography weight='medium'>{t('style.effects')}</Typography>
      <FormField config={schema.effects.boxShadow} />

      <Typography weight='medium'>{t('elements.testAnswerFeedback.tags.indents')}</Typography>
      <FormField config={schema.indents.marginTop} />
      <FormField config={schema.indents.marginBottom} />
    </>
  )
}

export default React.memo(BrandFeedback) as typeof BrandFeedback
